import AppConstants, { isProductionHost } from './AppConstants';
import PendoTags from './PendoTags';

// eslint-disable-next-line import/prefer-default-export
export { AppConstants, PendoTags, isProductionHost };
